import { mapState, mapGetters } from 'vuex';

export default {
	data() {
		return {
			isActiveTooltipComponent: false,
			removeOnClick: false,
		};
	},
	computed: {
		...mapState({
			activeTooltip: state => state.tutorial.activeTooltip,
		}),
		...mapGetters(["currentTooltip", "nextTooltipExists"]),
		tooltipLocation() {
			return this.currentTooltip.tooltip_object;
		},
		tooltipCatIndex() {
			return this.currentTooltip.cat_index;
		},
		tooltipMessage() {
			return this.currentTooltip.message;
		},
		tooltipShowing() {
			return this.activeTooltip && this.isActiveTooltipComponent;
		},
	},
	methods: {
		addTooltipListener() {
			document.addEventListener("click", this.hideTooltip, {
				capture: false,
				once: true,
			});
		},
		showTooltip() {
			this.isActiveTooltipComponent = true;
			this.$store.dispatch("pauseTimers");
			this.$store.commit("activateTooltip");
		},
		hideTooltip() {
			this.isActiveTooltipComponent = false;
			this.$store.dispatch("startClock");
			this.$store.commit("deactivateTooltip");

			if (this.nextTooltipExists) {
				this.$store.commit("incrementTooltipIndex");
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/mixins/tooltips.js